import Switch from 'src/components/primitives/Switch/Switch';
import Tooltip from 'src/components/primitives/Tooltip/Tooltip';
import { ReactNode } from 'react';
import { cm } from 'src/utils/classNames';
import { DefinitionTooltipID } from 'src/components/Tooltip/DefinitionTooltip/definitionTooltipConfig';
import DefinitionTooltip from 'src/components/Tooltip/DefinitionTooltip/DefinitionTooltip';
import { WithClassName } from 'src/utils/UtilityTypes';

interface SettingsSwitchProps extends WithClassName {
	label: ReactNode;
	checked: boolean;
	onChange: (checked: boolean) => void;
	disabled?: boolean;
	tooltipContent?: string | ReactNode;
	tooltipDefinitionId?: DefinitionTooltipID;
}

const SettingsSwitch = ({
	label,
	checked,
	onChange,
	disabled,
	tooltipContent,
	tooltipDefinitionId,
	className,
}: SettingsSwitchProps) => {
	const content = (() => {
		if (tooltipDefinitionId) {
			return (
				<DefinitionTooltip definitionId={tooltipDefinitionId}>
					{label}
				</DefinitionTooltip>
			);
		}

		if (tooltipContent) {
			return <Tooltip content={tooltipContent}>{label}</Tooltip>;
		}

		return label;
	})();

	return (
		<div
			className={cm(
				'flex items-center justify-between typo-b4 text-text-default',
				className
			)}
		>
			<span className="flex items-center gap-x-xs">{content}</span>

			<Switch
				size="sm"
				checked={checked}
				disabled={disabled}
				onCheckedChange={onChange}
			/>
		</div>
	);
};

export default SettingsSwitch;
